export enum TextFieldSize {
  Small = 'small',
  Large = 'large',
}
